import { addToPestPacOff, addToPestPacOn } from '../constants'

/**
 * Private source data backing the field-settings registry.
 *
 * The ordering and combining arrays are read only by `leadFieldConfig` /
 * `opportunityFieldConfig`, which derive each field's `order` and
 * `combineWithNext` from them at module init; every consumer then reads those
 * properties through `fieldConfigs.ts` rather than these arrays. The options,
 * title, and validation-message tables are read by `FieldSettingsCard`.
 * Nothing outside this folder consumes any of them, which is why they live
 * here rather than in `constants.tsx`.
 *
 * `order` is derived from array *position* in `customOrder`, so reordering
 * that array changes the order fields render in on the settings page. Note
 * this is the *display* order, which is deliberately not the server's seed
 * order that `leadFieldIds` / `opportunityFieldIds` are written in.
 *
 * `combineTopCards` still lists `firstNameLastName`, a field id that migration
 * `20240802071308` split into `firstName` / `lastName` and deleted. The entry
 * is inert — no such setting can come back from the server — and is kept only
 * so this array stays a faithful copy of the pre-refactor source data.
 */

export const customOrder = [
  'addToPestPac',
  'firstName',
  'lastName',
  'firstNameLastName',
  'company',
  'address',
  'phoneNumber',
  'emailAddresses',
  'altPhoneNumber',
  'locationTypeId',
  'divisionId',
  'preferredMethodOfContact',
  'preferredTimeOfContact',
  'salesTeamId',
  'ownerId',
  'assigneeId',
  'salesFunnelId',
  'salesFunnelStageId',
  'campaignId',
  'leadSourceId',
  'referral',
  'targetPests',
  'expectedClosingDate',
  'nextActionDate',
  'note',
  'useSystemName',
  'opportunityName',
  'opportunityStageId',
]

export const combineTopCards = [
  'firstNameLastName',
  'phoneNumber',
  'firstName',
  'lastName',
]

const nameValidationMessage =
  'You must collect one of the three fields below: First Name, Last Name, or Company Name in order to add a lead.'

export const validationMessages = [
  {
    key: 'firstName',
    message: nameValidationMessage,
  },
  {
    key: 'phoneNumber',
    message:
      'You must collect one of the two fields: Phone or Email Address in order to add a lead.',
  },
]

export const titleValues = [
  {
    key: 'addToPestPac',
    message: 'Default setting',
  },
  {
    key: 'opportunityStageId',
    message: 'Choose display option',
  },
]

export const fieldOptions = [
  {
    key: 'addToPestPac',
    values: [
      { label: 'Off', value: addToPestPacOff },
      { label: 'On', value: addToPestPacOn },
    ],
  },
  {
    key: 'opportunityStageId',
    values: [
      { label: 'Stage meter', value: 'meter' },
      { label: 'Drop down', value: 'select' },
    ],
  },
]
